__turbopack_context__.v({
  "checkbox": "_0PG9sq_checkbox",
  "container": "_0PG9sq_container",
  "label": "_0PG9sq_label",
});
